var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
var CommissionRange = /** @class */ (function (_super) {
    __extends(CommissionRange, _super);
    function CommissionRange() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // 初始化数据
        _this.dataSet = [];
        _this.scopeIndex = 0;
        // 控制弹框
        _this.dialog = {
            isOpenRecoveryRate: false
        };
        return _this;
    }
    CommissionRange.prototype.mounted = function () {
        if (this.dataSet.length === 0) {
            this.addDomain();
        }
    };
    /**
     * 添加
     */
    CommissionRange.prototype.addDomain = function () {
        var domain = {
            productId: '',
            overduePeriodStart: '',
            overduePeriodEnd: '',
            recoverRateStart: '',
            recoverRateEnd: '',
            commissionRate: '',
            commissionAmount: '',
            operate: '',
        };
        this.dataSet.push(domain);
    };
    /**
     * 移除
     */
    CommissionRange.prototype.removeDomain = function (index) {
        this.dataSet.splice(index, 1);
    };
    /**
     * 刷新数据
     */
    CommissionRange.prototype.refresh = function (dataSet) {
        var _a;
        this.dataSet.length = 0;
        if (!dataSet || dataSet.length === 0) {
            this.addDomain();
        }
        else {
            (_a = this.dataSet).push.apply(_a, dataSet);
        }
    };
    /**
     * 校验并获取佣金范围数据列的值
     */
    CommissionRange.prototype.getDataSet = function () {
        var dataSet = this.dataSet;
        for (var i = 0; i < dataSet.length; i++) {
            var item = dataSet[i];
            if (this.propData.strategyType === 'ENABLED' && !item.productId)
                return {
                    unpass: true, message: "佣金范围第" + (i + 1) + "行产品类型不能为空"
                };
            if (!item.overduePeriodStart && item.overduePeriodStart !== 0)
                return {
                    unpass: true, message: "佣金范围第" + (i + 1) + "行逾期阶段起始值不能为空"
                };
            if (!item.overduePeriodEnd && item.overduePeriodEnd !== 0)
                return {
                    unpass: true, message: "佣金范围第" + (i + 1) + "行逾期阶段结束值不能为空"
                };
            if (!item.recoverRateStart && item.recoverRateStart !== 0)
                return {
                    unpass: true, message: "佣金范围第" + (i + 1) + "行回收率起始值不能为空"
                };
            if (!item.recoverRateEnd && item.recoverRateEnd !== 0)
                return {
                    unpass: true, message: "佣金范围第" + (i + 1) + "行回收率结束值不能为空"
                };
            if (this.propData.commissionStrategyType === 'RETURN_RATE') {
                if (item.commissionRate !== 0 && !item.commissionRate) {
                    return {
                        unpass: true, message: "佣金范围第" + (i + 1) + "行佣金比例不能为空"
                    };
                }
            }
            if (this.propData.commissionStrategyType === 'NUMBER' && (item.commissionAmount !== 0 && !item.commissionAmount))
                return {
                    unpass: true, message: "佣金范围第" + (i + 1) + "行佣金不能为空"
                };
        }
        return dataSet;
    };
    __decorate([
        Prop()
    ], CommissionRange.prototype, "propData", void 0);
    CommissionRange = __decorate([
        Component({
            components: {}
        })
    ], CommissionRange);
    return CommissionRange;
}(Vue));
export default CommissionRange;
